// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"d5f3203d","453":"98ba1a38"}[chunkId] + ".chunk.js";
};